/**
 * Reaktiver Dark-Mode-Status für Charts.
 *
 * echarts-Optionen werden beim Render gebaut und lesen die Theme-Farben
 * synchron (isDark() in echarts-theme.ts). Ohne diesen Hook bleiben Charts
 * nach dem Theme-Toggle in den alten Farben stehen, bis Daten neu laden —
 * der Hook beobachtet die `dark`-Klasse am <html> und triggert ein Re-Render.
 */

import { useEffect, useState } from 'react';

export function useIsDark(): boolean {
  const [dark, setDark] = useState(
    () => typeof document !== 'undefined' && document.documentElement.classList.contains('dark'),
  );

  useEffect(() => {
    const el = document.documentElement;
    const obs = new MutationObserver(() => setDark(el.classList.contains('dark')));
    obs.observe(el, { attributes: true, attributeFilter: ['class'] });
    return () => obs.disconnect();
  }, []);

  return dark;
}
